import getDataPathReduxUtil from 'modules/redux/utils/get-data-path'
import joinPathsStrUtil from 'utils/string/join-paths'

import {
  PRODUCTS_KEY,
  PRODUCTS_PATH
} from 'modules/product/redux/constants'

import getReduxSelector from 'modules/redux/selectors/get'

/**
 * @param productId
 * @returns {function(*): VariantWasSampledReduxItem}
 */
const getHasSampledProductDataSelector = productId => state => {
  const path = getDataPathReduxUtil(
    joinPathsStrUtil(PRODUCTS_PATH[PRODUCTS_KEY.HAS_SAMPLED_BY_ID], productId)
  )
  return getReduxSelector(path)(state)
}

export default getHasSampledProductDataSelector
